export enum UploadPhase {
  IDLE = 'idle',
  /** Pre-upload async work (folder creation); claims the guard early. */
  RESERVED = 'reserved',
  UPLOADING = 'uploading',
  /** Files are in S3 and registering; cancels are refused. */
  FINALIZING = 'finalizing',
}
